export default __webpack_public_path__ + "static/1-df2e774377dc29efe8a246aee6490511.jpeg";